'use client'
import styles from './Debugger.module.scss'
import dynamic from 'next/dynamic'
import { DebuggerProps } from './Debugger.types'
import { memo, useRef, useState } from 'react'
import { classNames } from '@/src/helpers/component'
import SVGDebug from '@/src/components/common/SVG/SVGDebug'
import useContainerResize from '@/src/hooks/useContainerResize'
import useContainerMutate from '@/src/hooks/useContainerMutated'

const MemoizedDynamicReactJson = memo(({ src }: { src: object }) => {
  const DynamicReactJson = dynamic(() => import('@microlink/react-json-view'), { ssr: false })
  return (
    <DynamicReactJson
      style={{ padding: '1em 50px' }}
      src={src}
      collapsed={8}
      displayObjectSize={true}
      theme={'embers'}
      enableClipboard={false}
      displayDataTypes={false}
      name={null}
      iconStyle={'circle'}
    />
  )
})
MemoizedDynamicReactJson.displayName = 'MemoizedDynamicReactJson'

export default function Debugger({ src }: DebuggerProps) {
  const [isOpen, setIsOpen] = useState(false)
  const [debugHeight, setDebugHeight] = useState(0)
  const ref = useRef<HTMLDivElement>(null)

  const _setDebugHeight = (_isOpen: boolean) => {
    setDebugHeight(_isOpen ? (ref.current?.scrollHeight ?? 0) : 0)
  }
  const resizer = useContainerResize<HTMLDivElement>(() => _setDebugHeight(isOpen))
  const mutator = useContainerMutate<HTMLDivElement>(() => _setDebugHeight(isOpen))

  const refHandler = (el: HTMLDivElement) => {
    ref.current = el
    resizer.target(el)
    mutator.target(el)
  }

  const onTogglerClick = () => {
    const _isOpen = !isOpen
    setIsOpen(_isOpen)
  }

  return (
    <div className={classNames(styles.container, isOpen ? styles.open : '')}>
      <div className={styles.toggler} onClick={onTogglerClick}>
        <SVGDebug width={25} height={25} />
      </div>
      <div ref={refHandler} className={styles.debugContainer} style={{ maxHeight: debugHeight }}>
        <MemoizedDynamicReactJson src={src} />
      </div>
    </div>
  )
}
